import React from "react";

const LandingPage = () => {
  return (
    <header style={{ textAlign: "center", padding: "5rem" }}>
      <h1>Welcome to BSG Project</h1>
      <p>Explore events and share your feedback!</p>
    </header>
  );
};

export default LandingPage;
